import type { IIncidentProvider } from './types';
import { MockProvider } from './mock_provider';
import { PagerDutyProvider } from './pagerduty_provider';

let _provider: IIncidentProvider | null = null;

export function getIncidentProvider(): IIncidentProvider {
  if (_provider) return _provider;
  const key = (import.meta as any).env?.VITE_PAGERDUTY_KEY as string | undefined;
  if (key) {
    _provider = new PagerDutyProvider({ integrationKey: key });
  } else {
    _provider = new MockProvider();
  }
  return _provider;
}

export function isPagerDutyActive(): boolean {
  return Boolean((import.meta as any).env?.VITE_PAGERDUTY_KEY);
}
